// components/shared/EmptyState.jsx
export function EmptyState({
  icon = "📭",
  title = "No hay datos",
  message,
  action,
  primaryColor = "#ea580c",
}) {
  return (
    <div className="text-center py-12">
      <div
        className="inline-flex items-center justify-center w-14 h-14 rounded-2xl mb-4 border"
        style={{ backgroundColor: `${primaryColor}12`, borderColor: `${primaryColor}25` }}
      >
        <span className="text-2xl">{icon}</span>
      </div>

      <h3 className="text-lg font-semibold text-white">{title}</h3>

      {message && <p className="text-slate-400 mt-2 mb-4 max-w-md mx-auto">{message}</p>}

      {action && <div className="flex justify-center">{action}</div>}
    </div>
  );
}
